import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { showError, showSuccess } from "common/ToastNotifications";
import { AiModelRouting as AiModelRoutingView, LoadingOverlay, ProhibitedArea } from "components";
import actions from "store/actions";

function AiModelRouting(props) {
  const prev = useRef(null);
  if (prev.current === null) {
    prev.current = {
      upsertProviderResult: props.upsertProviderResult,
      deleteProviderResult: props.deleteProviderResult,
      upsertBindingResult: props.upsertBindingResult,
      deleteBindingResult: props.deleteBindingResult,
    };
  }

  useEffect(() => {
    props.getAiGatewayPermission();
    props.getProviderCatalog();
    props.getProviders();
    props.getModelBindings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.upsertProviderResult !== prev.current.upsertProviderResult) {
      prev.current.upsertProviderResult = props.upsertProviderResult;
      if (props.upsertProviderResult && props.upsertProviderResult.success === false) {
        showError(props.upsertProviderResult.message || "Could not save the provider.");
      } else if (props.upsertProviderResult) {
        showSuccess("Provider saved.");
        props.getProviders();
      }
    }
  }, [props.upsertProviderResult]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.deleteProviderResult !== prev.current.deleteProviderResult) {
      prev.current.deleteProviderResult = props.deleteProviderResult;
      if (props.deleteProviderResult && props.deleteProviderResult.success === false) {
        showError(props.deleteProviderResult.message || "Could not remove the provider.");
      } else if (props.deleteProviderResult) {
        showSuccess("Provider configuration removed.");
        props.getProviders();
      }
    }
  }, [props.deleteProviderResult]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.upsertBindingResult !== prev.current.upsertBindingResult) {
      prev.current.upsertBindingResult = props.upsertBindingResult;
      if (props.upsertBindingResult && props.upsertBindingResult.success === false) {
        showError(props.upsertBindingResult.message || "Could not save the model binding.");
      } else if (props.upsertBindingResult) {
        showSuccess("Model binding saved.");
        props.getModelBindings();
      }
    }
  }, [props.upsertBindingResult]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (props.deleteBindingResult !== prev.current.deleteBindingResult) {
      prev.current.deleteBindingResult = props.deleteBindingResult;
      if (props.deleteBindingResult && props.deleteBindingResult.success === false) {
        showError(props.deleteBindingResult.message || "Could not remove the model binding.");
      } else if (props.deleteBindingResult) {
        showSuccess("Model binding removed.");
        props.getModelBindings();
      }
    }
  }, [props.deleteBindingResult]); // eslint-disable-line react-hooks/exhaustive-deps

  if (props.permission && !props.permission.canView) {
    return <ProhibitedArea />;
  }

  return (
    <div className="relative" style={{ minHeight: 400 }}>
      <LoadingOverlay busy={props.loading} spinner message="Please wait..." />
      <AiModelRoutingView
        catalog={props.catalog}
        providers={props.providers}
        bindings={props.bindings}
        permission={props.permission}
        providerModels={props.providerModels}
        providerModelsLoading={props.providerModelsLoading}
        providerModelsSource={props.providerModelsSource}
        onFetchModels={props.getProviderModels}
        onSaveProvider={props.upsertProvider}
        onRemoveProvider={props.deleteProvider}
        onSaveBinding={props.upsertModelBinding}
        onRemoveBinding={props.deleteModelBinding}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  catalog: state.aiModelRouting.catalog,
  providers: state.aiModelRouting.providers,
  bindings: state.aiModelRouting.bindings,
  permission: state.aiModelRouting.permission,
  loading: state.aiModelRouting.loading,
  providerModels: state.aiModelRouting.providerModels,
  providerModelsLoading: state.aiModelRouting.providerModelsLoading,
  providerModelsSource: state.aiModelRouting.providerModelsSource,
  upsertProviderResult: state.aiModelRouting.upsertProviderResult,
  deleteProviderResult: state.aiModelRouting.deleteProviderResult,
  upsertBindingResult: state.aiModelRouting.upsertBindingResult,
  deleteBindingResult: state.aiModelRouting.deleteBindingResult,
});

const mapDispatchToProps = (dispatch) => ({
  getProviderCatalog: () => dispatch(actions.getProviderCatalogRequest()),
  getProviders: () => dispatch(actions.getProvidersRequest()),
  getModelBindings: () => dispatch(actions.getModelBindingsRequest()),
  getAiGatewayPermission: () => dispatch(actions.getAiGatewayPermissionRequest()),
  getProviderModels: (provider) => dispatch(actions.getProviderModelsRequest(provider)),
  upsertProvider: (provider, config) => dispatch(actions.upsertProviderRequest(provider, config)),
  deleteProvider: (provider) => dispatch(actions.deleteProviderRequest(provider)),
  upsertModelBinding: (capability, binding) => dispatch(actions.upsertModelBindingRequest(capability, binding)),
  deleteModelBinding: (capability) => dispatch(actions.deleteModelBindingRequest(capability)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AiModelRouting);
